export enum PageTypes {
  Admin = "admin",
  TeamManager = "team-manager",
}
